import { dateFormat, daysFormat, getStringTime } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
const goodsShipment = {
  goodsShipment: {
    name: 'goodsShipment',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'dialogForm',
      'deviceData'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'goodsShipment/addGoodsShipment',
    editFun: 'goodsShipment/editGoodsShipment',
    getListFun: 'goodsShipment/getGoodsShipmentList',
    deleteFun: 'goodsShipment/deleteGoodsShipment',
    detailPage: [
      {
        buttonName: '新增',
        name: 'goodsShipment',
        type: 'stepForm',
        theme: 'goodsShipment',
        step: 'goodsShipmentInfo',
        label: '新增物资运输单信息'
      },
      {
        buttonName: '编辑',
        name: 'goodsShipment',
        type: 'stepForm',
        theme: 'goodsShipment',
        step: 'goodsShipmentInfo',
        label: '编辑物资运输单信息',
        checkType: 'checkByUid',
        checkFun: 'goodsShipment/getGoodsShipmentInfo'
      },
      {
        buttonName: '查看',
        name: 'goodsShipment',
        type: 'stepForm',
        theme: 'goodsShipment',
        step: 'goodsShipmentInfo',
        label: '查看物资运输单信息',
        checkType: 'checkByUid',
        checkFun: 'goodsShipment/getGoodsShipmentInfo'
      },
      {
        buttonName: '查看业务单',
        name: (params) => {
          return params.formValues && params.formValues.workName
        },
        type: 'stepForm',
        theme: 'goodsShipment',
        step: (params) => {
          return params.formValues && params.formValues.workName + 'Info'
        },
        label: '查看业务单信息',
        checkType: 'checkByKey',
        checkKey: 'workUid',
        checkFun: (params) => {
          return params.formValues && params.formValues.getWorkInfo
        },
        pageStatus: 'check'
      },
      {
        buttonName: '查看生产单',
        name: 'productionTaskView',
        type: 'dialogForm',
        label: '查看生产单信息',
        checkType: 'checkByKey',
        checkKey: 'productionTaskUid',
        checkFun: 'mixingProduction/getMixingProductionInfo',
        pageStatus: 'check'
      },
      {
        buttonName: '运输作业部位及内容',
        name: (params) => {
          return params.currentRow && params.currentRow.workName
        },
        type: 'stepForm',
        theme: 'goodsShipment',
        step: (params) => {
          return params.currentRow && params.currentRow.workName + 'Info'
        },
        label: '查看业务单信息',
        checkType: 'checkByKey',
        checkKey: 'workUid',
        checkFun: (params) => {
          return params.currentRow && params.currentRow.getWorkInfo
        },
        pageStatus: 'check'
      },
      {
        buttonName: '签收',
        name: 'signing',
        type: 'dialogForm',
        checkType: 'useRowData'
      },
      {
        buttonName: '监控',
        name: 'deviceData',
        type: 'deviceData',
        label: '查看物联监控数据',
        theme: 'goodsShipment',
        step: 'deviceDataInfo',
        checkType: 'checkByKey',
        checkKey: 'carEnterUid',
        checkFun: 'officialCar/getOfficialCarEnterInfo',
        pageStatus: 'current'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      shipmentType: '混凝土运输',
      shipmentStatus: '',
      signingType: '',
      period: [],
      query: ''
    },
    selectData: [
      {
        key: 'shipmentType',
        label: '运输类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.shipmentType
        },
        span: 8
      },
      {
        key: 'shipmentStatus',
        label: '运输状态',
        type: 'select',
        options: (params) => {
          return params.dictionarys.shipmentStatus
        },
        span: 8
      },
      {
        key: 'signingType',
        label: '签收类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.signingType
        },
        span: 8
      },
      {
        key: 'period',
        label: '运输时间',
        type: 'time',
        timetype: 'daterange',
        span: 8
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '运输单编号/供方名称/车牌号/驾驶员',
        span: 8
      }
    ],
    rowData: (params) => {
      return params.state.goodsShipment.goodsShipmentList.result
    },
    rowTotal: (params) => {
      return params.state.goodsShipment.goodsShipmentList.totalSize
    },
    columns: [
      {
        prop: 'shipmentNum',
        label: '运输单编号',
        width: '160px'
      },
      {
        prop: 'carCode',
        label: '运输车牌号',
        width: '100px'
      },
      {
        prop: 'driverName',
        label: '驾驶员',
        tooltip: () => {
          return (row) => {
            return { tipValue: row.driverPhone }
          }
        },
        width: '80px'
      },
      {
        prop: 'supplierName',
        label: '供方名称',
        width: '130px',
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
                row.supplierResponPerson + '\xa0\xa0' + row.supplierResponPhone
            }
          }
        }
      },
      {
        prop: 'shipmentQuantity',
        label: '运输方量(m³)',
        width: '80px'
      },
      {
        prop: 'workInfo',
        label: '运输作业部位及内容',
        width: '280px',
        drillDown: true,
        tooltip: () => {
          return (row) => {
            return { tipValue: row.workType + '\xa0\xa0' + row.workCode }
          }
        },
        overflow: false
      },
      {
        prop: 'trainNumber',
        label: '业务车次',
        width: '80px'
      },
      {
        prop: 'shipmentStatus',
        label: '运输状态',
        width: '110px',
        tag: (params) => {
          return params.dictionarys.shipmentStatus
        },
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
                row.shipmentStatus === '待装车'
                  ? '待绑定车辆装车'
                  : row.shipmentStatus === '待发车'
                  ? '装车时间：' + row.loadTime
                  : row.shipmentStatus === '运输中'
                  ? '发车时间：' + row.departureTime
                  : '签收时间：' +
                    row.signingTime +
                    (row.signingOpinion
                      ? '\xa0\xa0签收意见：' + row.signingOpinion
                      : '')
            }
          }
        }
      },
      {
        prop: 'signingType',
        label: '签收类型',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.signingType
        }
      },
      {
        prop: 'signee',
        label: '签收人',
        width: '80px'
      },
      {
        label: '操作',
        width: '420px',
        buttons: setTableButtons(['查看', '编辑', '发车', '删除', '监控', '二维码'])
      }
    ],
    hasPagination: true,
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      orgName: (params) => {
        return params.orgName
      },
      workUid: '',
      productionTaskUid: '',
      shipmentType: '',
      shipmentNum: 'YSD' + getStringTime(new Date()),
      supplierName: '',
      supplierResponPerson: '',
      supplierResponPhone: '',
      carEnterUid: '',
      carCode: '',
      driverName: '',
      driverPhone: '',
      trainNumber: 1,
      shipmentQuantity: null,
      shipmentQuantityUnit: '',
      loadTime: '',
      destinationDisplay: '',
      destinationAddress: '',
      destinationLng: '',
      destinationLat: '',
      remarks: '',
      shipmentStatus: '待发车'
    },
    formRules: {
      workUid: [
        {
          required: (params) => {
            const type =
              params.formValues && params.formValues.shipmentType
            const list =
              (params.dictionarys && params.dictionarys.shipmentType) || []
            return list.some((item) => item && item.label === type)
          },
          message: '请选择业务单信息',
          trigger: 'change'
        },
        {
          validator: (params) => {
            return params.validate.validateWorkUid
          },
          trigger: 'change'
        }
      ],
      productionTaskUid: [
        {
          required: (params) => {
            return (
              params.formValues &&
              params.formValues.shipmentType === '混凝土运输'
            )
          },
          message: '混凝土运输须选择生产任务',
          trigger: 'change'
        },
        {
          validator: (params) => {
            return params.validate.validateProductionTaskUid
          },
          trigger: 'change'
        }
      ],
      shipmentType: [
        {
          required: true,
          message: '运输类型不能为空',
          trigger: 'blur'
        }
      ],
      supplierName: [
        {
          required: true,
          message: '供方名称不能为空',
          trigger: 'blur'
        }
      ],
      supplierResponPerson: [
        {
          required: true,
          message: '供方负责人不能为空',
          trigger: 'blur'
        }
      ],
      carCode: [
        {
          required: true,
          message: '运输车牌号不能为空',
          trigger: 'blur'
        }
      ],
      driverName: [
        {
          required: true,
          message: '驾驶员不能为空',
          trigger: 'blur'
        }
      ],
      trainNumber: [
        {
          required: true,
          message: '业务车次不能为空',
          trigger: 'blur'
        }
      ],
      shipmentQuantity: [
        {
          required: true,
          message: '运输量不能为空',
          trigger: ['blur', 'change']
        },
        {
          validator: (params) => {
            return params.validate.validateShipmentQuantityPositive
          },
          trigger: ['blur', 'change']
        },
        {
          validator: (params) => {
            return params.validate.validateShipmentQuantity
          },
          trigger: ['blur', 'change']
        }
      ],
      loadTime: [
        {
          required: true,
          message: '装货时间不能为空',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '物资运输单信息',
      cardTip: (params) => {
        if (params.pageStatus !== 'add') {
          return '编辑不可修改业务单或任务单；如需修改业务单或任务单，联系生产管理员处置转移或删除重新新增。'
        }
        return ''
      },
      disabledButtonCodes: (params) => {
        const form = params.formValues || {}
        if (form._pendingLoadBlocked) return ['post', 'buffer']
        return []
      },
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'shipmentNum',
          label: '运输单编号',
          type: 'input',
          disabled: true
        },
        {
          key: 'shipmentType',
          label: '运输类型描述',
          type: 'select',
          options: (params) => {
            return params.dictionarys.shipmentType
          },
          placeholder: '运输类型不在备选类型时，请输入运输任务及位置简要描述',
          filterable: true,
          create: true,
          disabled: (params) => params.pageStatus !== 'add'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'workInfo' : 'workUid'
          },
          label: '业务单信息',
          type: 'select',
          options: (params) => {
            const form = params.formValues || {}
            const current = form.workUid
            // 不因待装车过滤选项；当前项始终保留
            const list = (params.getters.workList || []).slice()
            if (
              current &&
              !list.some((item) => item && item.value === current)
            ) {
              const order = form.orderInfo || {}
              list.unshift({
                value: current,
                label:
                  order.pouringOrderCode ||
                  form.workInfo ||
                  form.workName ||
                  current
              })
            }
            return list
          },
          placeholder: '内置运输类型须选择业务单',
          filterable: true,
          checkByValue: true,
          disabled: (params) => {
            if (params.pageStatus !== 'add') return true
            const form = params.formValues || {}
            return !!form._pendingLoadBlocked || !!form._lockRelation
          },
          echoLabelKey: 'workInfo',
          check: (params) => {
            return params.formValues &&
              params.formValues.workName &&
              params.formValues.workUid
              ? '查看业务单'
              : ''
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'check'
              ? 'productionTaskCode'
              : 'productionTaskUid'
          },
          label: '生产单信息',
          type: 'select',
          options: (params) => {
            const form = params.formValues || {}
            const current = form.productionTaskUid
            // 不因待装车过滤；选项展示可装车量
            const raw =
              (params.state.mixingProduction &&
                params.state.mixingProduction.orderTaskOptions) ||
              []
            const list = raw.map((item) => {
              if (!item) return item
              const loadable =
                item.taskStatus === '1' || item.taskStatus === 1
                  ? item.currentBatchQuantity
                  : item.remainQuantity
              const qty =
                loadable != null && loadable !== ''
                  ? Number(loadable)
                  : null
              const pendingTag = item.hasPendingLoad ? '【待装车】' : ''
              const base =
                item.label ||
                item.taskCode ||
                item.value ||
                item.uid ||
                ''
              // 避免重复拼接可装量
              const hasQty = String(base).indexOf('可装') >= 0
              const qtyText =
                !hasQty && qty != null && !isNaN(qty)
                  ? ' 可装' + qty + 'm³'
                  : ''
              return Object.assign({}, item, {
                value: item.value || item.uid,
                label: base + qtyText + pendingTag
              })
            })
            if (
              current &&
              !list.some(
                (item) =>
                  item && (item.value === current || item.uid === current)
              )
            ) {
              list.unshift({
                value: current,
                label: form.productionTaskCode || current
              })
            }
            return list
          },
          placeholder: '内置运输类型须选择生产单（范围由业务单确定）',
          filterable: true,
          checkByValue: true,
          clearable: true,
          disabled: (params) => {
            if (params.pageStatus !== 'add') return true
            const form = params.formValues || {}
            return !!form._pendingLoadBlocked || !!form._lockRelation
          },
          echoLabelKey: 'productionTaskCode',
          check: (params) => {
            return params.formValues && params.formValues.productionTaskUid
              ? '查看生产单'
              : ''
          }
        },
        {
          key: 'trainNumber',
          label: '业务车次',
          type: 'input',
          disabled: true
        },
        {
          key: 'shipmentQuantity',
          label: '运输数量',
          type: 'input',
          placeholder: '请输入大于0的数值',
          units: (params) => {
            return params.dictionarys.unit
          },
          number: true,
          disabled: (params) => {
            if (params.pageStatus === 'add') return false
            const form = params.formValues || {}
            if (form.shipmentStatus !== '待装车') return true
            if (form._quantityEditable === false) return true
            if (form._quantityEditable === true) return false
            // 物料运输列表编辑：待装车默认可改，其它状态只读
            return form.shipmentStatus !== '待装车'
          }
        },
        {
          key: 'supplierName',
          label: '供方名称',
          type: 'select',
          options: (params) => {
            var supplierName = params.state.organization.orgFactory.concat([
              { label: params.orgName, value: params.orgValue }
            ])
            return supplierName
          },
          placeholder:
            '请输入名称在供方机构中搜索选择，如果没有直接输入名称新增',
          filterable: true,
          checkByValue: true,
          create: true
        },
        {
          key: 'supplierResponPerson',
          label: '供方联系人',
          type: 'input'
        },
        {
          key: 'supplierResponPhone',
          label: '供方联系电话',
          type: 'input'
        },
        {
          key: 'carCode',
          label: '运输车牌号',
          type: 'select',
          options: (params) => {
            const form = (params && params.formValues) || {}
            const list =
              (params.getters && params.getters['officialCar/noExitCar']) ||
              []
            const mapCar = (item) => {
              const parts = [item.carCode, item.carName, item.carModel].filter(
                (v) => v != null && String(v).trim() !== ''
              )
              return Object.assign({}, item, {
                value: item.carCode,
                label: parts.length ? parts.join(' / ') : item.carCode
              })
            }
            if (form._shipmentCarRemoteAll) {
              return list.map(mapCar)
            }
            const type = form.shipmentType || ''
            if (!type) return list.map(mapCar)
            return list
              .filter((item) => item && item.carUsage === type)
              .map(mapCar)
          },
          placeholder:
            '请按运输类型在进场车辆中搜索选择，没有对应类型时可输入远程搜索全部进场车辆，仍没有则点击去进场车辆办理进场',
          filterable: true,
          remote: true,
          create: false,
          checkByValue: true,
          optionCustom: false,
          check: (params) => {
            const form = (params && params.formValues) || {}
            const list =
              (params.getters && params.getters['officialCar/noExitCar']) ||
              []
            if (form._shipmentCarRemoteAll) {
              return list.length ? '' : '去进场车辆'
            }
            const type = form.shipmentType || ''
            const matched = type
              ? list.filter((item) => item && item.carUsage === type)
              : list
            return matched.length ? '' : '去进场车辆'
          },
          disabled: (params) => {
            const status =
              params.formValues && params.formValues.shipmentStatus
            return status && status !== '待发车' && status !== '待装车'
          }
        },
        {
          key: 'driverName',
          label: '驾驶员',
          type: 'input'
        },
        {
          key: 'driverPhone',
          label: '司机手机号码',
          type: 'input'
        },
        {
          key: 'loadTime',
          label: '装货时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          disabled: (params) => {
            return params.formValues &&
              params.formValues.shipmentStatus === '待发车'
              ? false
              : false
          }
        },
        {
          key: 'destinationDisplay',
          label: '运输目的地',
          type: 'input',
          placeholder: '可输入地址，或点选地图获取位置与坐标',
          inputButton: '地图点选',
          buttonIcon: 'el-icon-location-outline input_button_i'
        },
        {
          key: 'remarks',
          label: '备注信息',
          type: 'input',
          placeholder: '请输入运输、验收等相关注意事项或特别说明'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'shipmentStatus' : null
          },
          type: 'input',
          label: '运输状态'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'departureTime' : null
          },
          type: 'input',
          label: '发车时间'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'signee' : null
          },
          type: 'input',
          label: '签收人'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'signingType' : null
          },
          type: 'input',
          label: '签收类型'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'signingOpinion' : null
          },
          type: 'input',
          label: '签收意见'
        }
      ]
    },
    signing: {
      name: 'signing',
      title: '运输单签收',
      editFun: 'goodsShipment/editGoodsShipment',
      getParentFun: 'goodsShipment/getGoodsShipmentList',
      formParams: {
        carCode: (params) => params.state.currentRow.goodsShipment.carCode,
        trainNumber: (params) =>
          params.state.currentRow.goodsShipment.trainNumber,
        workUid: (params) => params.state.currentRow.goodsShipment.workUid,
        shipmentType: (params) =>
          params.state.currentRow.goodsShipment.shipmentType,
        signingTime: daysFormat(new Date()) + ' ' + dateFormat(new Date()),
        signingType: '',
        shipmentStatus: '',
        signingOpinion: '',
        signee: (params) => {
          return params.personName || params.userName || ''
        }
      },
      formRules: {
        shipmentStatus: [
          {
            required: true,
            message: '运输状态不能为空',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateShipmentStatus
            },
            trigger: 'blur'
          }
        ],
        signingType: [
          {
            required: true,
            message: '签收类型不能为空',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateShipmentStatus
            },
            trigger: 'blur'
          }
        ],
        signingOpinion: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.shipmentStatus === '不合格签收'
              )
            },
            message: '不合格签收时签收意见不能为空',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'carCode',
          label: '运输车牌号',
          type: 'input',
          disabled: true
        },
        {
          key: 'trainNumber',
          label: '业务车次',
          type: 'input',
          disabled: true
        },
        {
          key: 'signingTime',
          label: '签收时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss'
        },
        {
          key: 'signingType',
          label: '签收类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.signingType
          },
          placeholder: '请选择是否业务终车签收'
        },
        {
          key: 'shipmentStatus',
          label: '运输状态',
          type: 'select',
          options: [
            { value: '合格签收', label: '合格签收' },
            { value: '不合格签收', label: '不合格签收' }
          ],
          placeholder: '请选择是否合格签收'
        },
        {
          key: 'signingOpinion',
          label: '签收意见',
          type: 'input',
          placeholder: '不合格签收请务必留下签收意见'
        }
      ]
    },
    productionTaskView: {
      name: 'productionTaskView',
      title: '查看生产单信息',
      formParams: {},
      formRules: {},
      formData: [
        {
          key: 'taskCode',
          label: '生产任务编号',
          type: 'input',
          disabled: true
        },
        {
          key: 'taskStatusCn',
          label: '任务状态',
          type: 'input',
          disabled: true
        },
        {
          key: 'pouringOrderCode',
          label: '浇筑令编号',
          type: 'input',
          disabled: true
        },
        {
          key: 'pouringLocation',
          label: '浇筑部位',
          type: 'input',
          disabled: true
        },
        {
          key: 'strengthGrade',
          label: '强度等级',
          type: 'input',
          disabled: true
        },
        {
          key: 'appliedQuantity',
          label: '申请方量',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'producedQuantity',
          label: '已生产方量',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'currentBatchQuantity',
          label: '本批可装车量',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'remainQuantity',
          label: '剩余可生产',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'factoryName',
          label: '拌和站',
          type: 'input',
          disabled: true
        },
        {
          key: 'remarks',
          label: '备注',
          type: 'input',
          disabled: true,
          span: 24
        }
      ]
    }
  },
  pouringOrder: {
    name: 'pouringOrder',
    componentTypes: ['navigate', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    formData: {
      card: '浇筑令信息',
      fields: [
        {
          key: 'pouringOrderCode',
          label: '浇筑令编号',
          type: 'input'
        },
        {
          key: 'subitemName',
          label: '浇筑分项',
          type: 'input'
        },
        {
          key: 'remarks',
          label: '浇筑部位',
          type: 'input'
        },
        {
          key: 'strengthGrade',
          label: '强度等级',
          type: 'input'
        },
        {
          key: 'designQuantity',
          label: '设计方量',
          inputButton: 'm³',
          type: 'input'
        },
        {
          key: 'historyApplied',
          label: '历史申请',
          inputButton: 'm³',
          type: 'input'
        },
        {
          key: 'plannedPouringTime',
          label: '计划浇筑时间',
          type: 'input'
        },
        {
          key: 'completedQuantity',
          label: '累计签收',
          inputButton: 'm³',
          type: 'input'
        }
      ]
    }
  },
  deviceData: {
    name: 'deviceData',
    componentTypes: ['navigate', 'deviceData'],
    cardTitle: '物联监控数据信息',
    formTitle: '物资运输单信息',
    formData: (params) => {
      var formData = [
        {
          key: 'laborCompanyName',
          label: '所属劳务公司',
          type: 'text'
        },
        {
          key: 'carCode',
          label: '车牌号',
          type: 'text'
        },
        {
          key: 'carModel',
          label: '车辆型号',
          type: 'text'
        },
        {
          key: 'approvedPenson',
          label: '核载人数',
          type: 'text'
        },
        {
          key: 'limitSpeed',
          label: '最大限速(km/h)',
          type: 'text'
        },
        {
          key: 'entryDate',
          label: '进场日期',
          type: 'text'
        },
        {
          key: 'driverName',
          label: '司机姓名',
          type: 'text'
        },
        {
          key: 'driverPhone',
          label: '司机手机号码',
          type: 'text'
        }
      ]
      if (params.pageStatus === 'current') {
        formData.push(
          {
            key: 'ownerName',
            label: '车主姓名',
            type: 'text'
          },
          {
            key: 'ownerPhone',
            label: '车主手机号码',
            type: 'text'
          },
          {
            key: 'carUsage',
            label: '车辆用途',
            type: 'text'
          },
          {
            key: 'stateCn',
            label: '车辆状态',
            type: 'tag'
          },
          {
            key: 'speed',
            label: '速度(km/h)',
            type: 'text'
          },
          {
            key: 'isOverSpeed',
            label: '是否超速',
            type: 'tag'
          },
          {
            key: 'addr',
            label: '当前位置',
            type: 'text'
          }
        )
      } else if (params.pageStatus === 'history') {
        formData.push(
          {
            key: 'mile',
            label: '行驶里程（km）',
            type: 'text'
          },
          {
            key: 'move_long',
            label: '行车时长',
            type: 'text'
          },
          {
            key: 'max_speed',
            label: '最高速度(km/h)',
            type: 'text'
          },
          {
            key: 'avg_speed',
            label: '平均速度(km/h)',
            type: 'text'
          },
          {
            key: 'overspeedNum',
            label: '超速次数',
            type: 'text'
          },
          {
            key: 'stop_long',
            label: '停车时长',
            type: 'text'
          },
          {
            key: 'stopNum',
            label: '停车次数',
            type: 'text'
          }
        )
      }
      return formData
    }
  }
}

export default goodsShipment
